import commons from '@/api/commons'

// initial state

const state = {
  tableItems: [],
  csvItems: [],
  tableItemsTotal: 0,
  itemDetail: {},
  loading: false
}

const mutations = {
  mutateTableItems (state, response) {
    state.tableItems = response.items
    state.tableItemsTotal = response.total
  },
  mutateCsvItems (state, response) {
    state.csvItems = response.items
  },
  mutateLoading (state) {
    state.loading = !state.loading
  },
  mutateItemDetail (state, response) {
    state.itemDetail = response
  }
}

const actions = {
  async getItems ({ commit }, response) {
    commit('mutateLoading')
    const items = await commons.getItems(response)
    commit('mutateTableItems', items)
    commit('mutateLoading')
  },
  async getItemDetail ({ commit }, response) {
    commit('mutateLoading')
    const item = await commons.getItemDetail(response)
    commit('mutateItemDetail', item)
    commit('mutateLoading')
  },
  async getCsvItems ({ commit }, response) {
    const item = await commons.getItems(response)
    commit('mutateCsvItems', item)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
